import path from 'node:path';
import { randomUUID } from 'node:crypto';
import camelCase from 'lodash/camelCase.js';
import { componentGenerator } from '@wix/gena';
import type { ActionSchema } from '@wix/cli-app-definitions';
import { getDashboardMenuPluginExtensionPath } from '@wix/cli-astro-definitions';
import { modifyExtensionsEntry } from '@wix/cli-project-extender';
import type { DashboardMenuPluginAction } from './DashboardMenuPluginWizard.js';
import { getExtensionRelativePaths } from '../../utils/extension-relative-paths.js';

// NOTE: path is relative to the build folder
const DASHBOARD_MENU_PLUGIN_TEMPLATE = path.resolve(
  __dirname,
  '../templates/astro/dashboard-menu-plugin'
);

export async function generateDashboardMenuPlugin(
  projectFolder: string,
  extended: string,
  actionType: DashboardMenuPluginAction,
  action: ActionSchema,
  route: string,
  title: string
) {
  const cwd = getDashboardMenuPluginExtensionPath(projectFolder, route);
  const { relativePathToConfigFile } = getExtensionRelativePaths({
    cwd,
    projectFolder,
    extensionFileName: route,
    codeFileType: 'ts', // TODO: no code file for menu plugin
  });

  const config = {
    id: randomUUID(),
    title,
    iconKey: 'Sparkles',
    extends: extended,
    action,
  };

  await modifyExtensionsEntry(
    projectFolder,
    camelCase(route),
    relativePathToConfigFile
  );

  return await componentGenerator({
    template: DASHBOARD_MENU_PLUGIN_TEMPLATE,
    projectFolder,
    cwd,
    data: {
      route,
      config,
      type: actionType.type,
    },
  });
}
